<template>
    <div>
        <router-view />
        <a id="subpage_redirect" href="#" style="display: none"></a>
        <tvb-cookies />
    </div>
</template>

<script setup name="App">
import { computed, provide, ref, watch, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useWindowSize } from '@vueuse/core'
import { encode } from 'js-base64'
import md5 from 'js-md5'
import qs from 'querystringify'
import { getCookie, setCookie } from '@/utils/cookies'
import TvbCookies from '@/components/TvbCookies/index.vue'
import { SSO_COOKIES } from '@/constants/index'
import { getSubpageUrl } from '@/utils/urlChecker.js'
import { onMounted } from 'vue'
import { useHead } from '@vueuse/head'

const { width, height } = useWindowSize()
onMounted(() => {
    if (import.meta.env.VITE_ENV === 'qa') {
        useHead({
            meta: [
                {
                    name: 'robots',
                    content: 'noindex'
                }
            ]
        })
    }
})

const route = useRoute()
const language = ref(route.params.language ?? 'tc')
const isMobile = computed(() => calcIsMobile())
/** 是否電腦設備  */
provide('isDesktop', window.device.desktop())
/** 是否顯示移動端界面  */
provide('isMobile', isMobile)
/** 窗口寬度  */
provide('width', width)
/** 窗口高度  */
provide('height', height)
/** 語言 */
provide('language', language)
/** 設置語言 */
provide('setLanguage', lang => {
    setTimeout(() => {
        language.value = lang
    }, 0)
})

watch(
    () => route.params,
    params => {
        language.value = params.language ?? 'tc'
    }
)

const calcIsMobile = () => {
    return window.device.mobile() && !document.fullscreenElement
}

const loginFreeUser = () => {
    const programmeConnect2021 = getCookie(SSO_COOKIES.programmeConnect2021)
    const programmeConnect2021Sales = getCookie(SSO_COOKIES.programmeConnect2021Sales)

    if (!programmeConnect2021) {
        setCookie(SSO_COOKIES.programmeConnect2021, encode(import.meta.env.VITE_FREE_KEY))
    }

    if (!programmeConnect2021Sales) {
        setCookie(
            SSO_COOKIES.programmeConnect2021Sales,
            md5.hex(`${import.meta.env.VITE_FREE_USER_ID}${import.meta.env.VITE_FREE_CKEY}`)
        )
    }
}

// TODO: https://tvbcom.atlassian.net/browse/TC-742
const redirectToSubpage = () => {
    const channel = getCookie('pg_channel')
    // eslint-disable-next-line camelcase
    const parent_cat = getCookie('pg_parent_cat')
    const category = getCookie('pg_category')
    const id = getCookie('pg_id')
    const sort = getCookie('pg_sort')
    const template = getCookie('pg_template')

    const params = {
        // eslint-disable-next-line no-extra-parens
        ...(channel && { channel }),
        // eslint-disable-next-line camelcase, no-extra-parens
        ...(parent_cat && { parent_cat }),
        // eslint-disable-next-line no-extra-parens
        ...(category && { category }),
        // eslint-disable-next-line no-extra-parens
        ...(id && { id }),
        // eslint-disable-next-line no-extra-parens
        ...(sort && { sort }),
        // eslint-disable-next-line no-extra-parens
        ...(template && { template })
    }

    const queryString = qs.stringify(params)
    window.console.log('redirectToSubpage', { channel, category }, queryString, params)
    if (queryString) {
        const subpage = getSubpageUrl(params)
        const href = `${import.meta.env.VITE_BASE_URL}${subpage}?${queryString}`

        const btn = document.getElementById('subpage_redirect')
        if (btn) {
            btn.href = href
            btn.click()
        } else {
            window.location.href = href
        }
        return true
    }
}

onBeforeMount(() => {
    const envParam = import.meta.env.VITE_ENV
    if (window.location.href.startsWith('http://') && envParam !== 'dev') {
        window.location.href = window.location.href.replace('http://', 'https://')
    }
    loginFreeUser()
})

onMounted(() => {
    redirectToSubpage()
})
</script>

<style scoped>
.logo {
    height: 6em;
    padding: 1.5em;
    will-change: filter;
    transition: filter 300ms;
}
.logo:hover {
    filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
    filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
